import { AppState } from "./models";
import { ohCaseSelector } from "./selectors";

const detailRoute = () => ({
    "/:ohCaseId": {
        title: (state: AppState) => ohCaseSelector(state).customerName || "Case",
        "/:reviewReportTaskId/referral-report": {
            title: "Referral Report",
        },
        "/referral-report/:viewReportTaskId": {
            title: "Referral Report",
        },
        "/:reviewReportTaskId/old-referral-report/*": {
            title: "Referral Report",
        },
        "/old-referral-report/*/:viewReportTaskId": {
            title: "Referral Report",
        },
        "/ppq-report/:viewReportTaskId": {
            title: "PPQ Report",
        },
        "/ppq": {
            title: "PPQ"
        },
        "/bbvReport": {
            title: "BBV Report"
        },
        "/health-surveillance-certificate/:taskId": {
            title: "Health Surveillance Certificate"
        },
        "/all-imms-completed-for-role-certificate/:taskId": {
            title: "All Immunisations Completed For Role Certificate"
        },
        "/immunisation-clear-certificate/:taskId": {
            title: "Immunisation Clear Certificate"
        },
        ...referralRoute,
        "/physiotherapyReferral": {
            title: "Physiotherapy Referral"
        },
        "/:reviewReportTaskId/old-physiotherapy-referral-report/*": {
            title: "Physiotherapy Referral Report",
        },
        "/:reviewReportTaskId/physiotherapy-referral-report": {
            title: "Physiotherapy Referral Report",
        },
        "/old-physiotherapy-referral-report/*/:viewReportTaskId": {
            title: "Physiotherapy Referral Report",
        },
        "/physiotherapy-referral-report/:viewReportTaskId": {
            title: "Physiotherapy Referral Report",
        },
        "/:reviewReportTaskId/mhp-treatment-report": {
            title: "MHP Treatment Report",
        },
        "/mhp-treatment-report/:viewReportTaskId": {
            title: "MHP Treatment Report",
        },
        "/sra": {
            title: "Stress Risk Assessment"
        },
        "/documents": {
            title: "Documents",
        }
    }
});

const referralRoute = {
    "/referral": {
        title: "Referral",
    }
};

export const routes = {
    "/cases": {
        title: "Cases",
        ...detailRoute(),
    }
};
